import { render, staticRenderFns } from "./createdOrder.vue?vue&type=template&id=26dda91c&scoped=true&"
import script from "./createdOrder.vue?vue&type=script&lang=js&"
export * from "./createdOrder.vue?vue&type=script&lang=js&"
import style0 from "./createdOrder.vue?vue&type=style&index=0&id=26dda91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dda91c",
  null
  
)

export default component.exports